/* Workzone - header:
   1) icone social prima delle icone ricerca/account/carrello (template #wz-social-tpl in snippets/meta-tags.liquid)
   1b) WhatsApp aggiunto ai social in fondo al menu da telefono (template #wz-wa-drawer-tpl)
   1c) campo di ricerca in cima al menu da telefono (stile in wz-mobile-search.css)
   2) testo che cambia nella pillola di ricerca a sinistra (stile in wz-search.css)
   3) ricerca SOLO PRODOTTI: i moduli di ricerca e la pagina risultati usano type=product.
   4) ricerca per CATEGORIA: parole come scarpe, giacche, guanti... portano al catalogo completo
      filtrato per "Tipo prodotto", ordinato per piu' venduti. */
(function () {
  var WORDS = ['felpe', 'polo', 't-shirt', 'scarpe S3', 'giacche soft-shell', 'pantaloni da lavoro', 'alta visibilit\u00e0', 'guanti', 'divise aziendali'];
  var TIPI = {
    'scarpe': 'Scarpe', 'scarpa': 'Scarpe', 'calzature': 'Scarpe', 'calzatura': 'Scarpe', 'scarponi': 'Scarpe', 'scarpe antinfortunistiche': 'Scarpe', 'scarpe da lavoro': 'Scarpe', 'antinfortunistiche': 'Scarpe',
    'guanti': 'Guanti', 'guanto': 'Guanti', 'guanti da lavoro': 'Guanti',
    'felpe': 'Felpe', 'felpa': 'Felpe', 'maglioni': 'Felpe', 'maglione': 'Felpe', 'pile': 'Felpe',
    'polo': 'Polo', 'polo da lavoro': 'Polo',
    't-shirt': 'T-shirt', 'tshirt': 'T-shirt', 't shirt': 'T-shirt', 'maglietta': 'T-shirt', 'magliette': 'T-shirt',
    'camicie': 'Camicie', 'camicia': 'Camicie',
    'pantaloni': 'Pantaloni', 'pantalone': 'Pantaloni', 'pantaloni da lavoro': 'Pantaloni', 'jeans': 'Pantaloni',
    'bermuda': 'Bermuda', 'pantaloncini': 'Bermuda', 'shorts': 'Bermuda',
    'giacche': 'Giacche e giubbotti', 'giacca': 'Giacche e giubbotti', 'giubbotti': 'Giacche e giubbotti', 'giubbotto': 'Giacche e giubbotti', 'giubbini': 'Giacche e giubbotti', 'softshell': 'Giacche e giubbotti', 'soft-shell': 'Giacche e giubbotti', 'soft shell': 'Giacche e giubbotti', 'parka': 'Giacche e giubbotti',
    'gilet': 'Gilet', 'gil\u00e8': 'Gilet', 'smanicato': 'Gilet',
    'alta visibilita': 'Alta visibilit\u00e0', 'alta visibilit\u00e0': 'Alta visibilit\u00e0', 'hi-vis': 'Alta visibilit\u00e0', 'fluo': 'Alta visibilit\u00e0',
    'camici': 'Camici e casacche', 'camice': 'Camici e casacche', 'casacche': 'Camici e casacche', 'casacca': 'Camici e casacche',
    'grembiuli': 'Grembiuli', 'grembiule': 'Grembiuli',
    'tute': 'Tute', 'tuta': 'Tute', 'pettorine': 'Tute', 'salopette': 'Tute',
    'intimo termico': 'Intimo termico', 'termico': 'Intimo termico', 'termica': 'Intimo termico'
  };
  function smartSearch() {
    if (!/\/search\/?$/.test(location.pathname)) return;
    var p = new URLSearchParams(location.search);
    if (!p.get('q')) return;
    var q = p.get('q').toLowerCase().trim().replace(/\s+/g, ' ');
    var tipo = TIPI[q];
    if (tipo) {
      var c = new URLSearchParams();
      if (p.get('preview_theme_id')) c.set('preview_theme_id', p.get('preview_theme_id'));
      c.set('filter.p.m.custom.tipo_wz', tipo);
      c.set('sort_by', 'best-selling');
      location.replace('/collections/all?' + c.toString());
      return;
    }
    if (p.get('type') !== 'product') { p.set('type', 'product'); location.replace(location.pathname + '?' + p.toString()); }
  }
  function productOnlyForms() {
    document.querySelectorAll('form[action*="/search"]').forEach(function (f) {
      if (f.querySelector('input[name="type"]')) return;
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = 'type'; i.value = 'product';
      f.appendChild(i);
    });
  }
  function social() {
    var tpl = document.getElementById('wz-social-tpl');
    var icons = document.querySelector('.header-wrapper .header__icons');
    if (!tpl || !icons || icons.querySelector('.wz-social')) return;
    icons.insertBefore(tpl.content.firstElementChild.cloneNode(true), icons.firstChild);
  }
  function drawerWA() {
    var tpl = document.getElementById('wz-wa-drawer-tpl');
    var list = document.querySelector('.menu-drawer .list-social');
    if (!tpl || !list || list.querySelector('.wz-wa')) return;
    list.appendChild(tpl.content.firstElementChild.cloneNode(true));
  }
  function drawerSearch() {
    var cont = document.querySelector('.menu-drawer .menu-drawer__navigation-container');
    if (!cont || cont.querySelector('.wz-drawer-search')) return;
    var f = document.createElement('form');
    f.className = 'wz-drawer-search';
    f.action = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'search';
    f.method = 'get';
    f.setAttribute('role', 'search');
    f.innerHTML = '<input type="search" name="q" placeholder="Cerca un prodotto o una categoria" aria-label="Cerca" autocomplete="off"><input type="hidden" name="type" value="product"><button type="submit" aria-label="Cerca"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5"/></svg></button>';
    var pv = new URLSearchParams(location.search).get('preview_theme_id');
    if (pv) { var h = document.createElement('input'); h.type = 'hidden'; h.name = 'preview_theme_id'; h.value = pv; f.appendChild(h); }
    cont.insertBefore(f, cont.firstChild);
  }
  function search() {
    var sum = document.querySelector('.header > .header__search > details > summary.header__icon--search');
    if (!sum || sum.querySelector('.wz-search-text')) return;
    var box = sum.querySelector('span') || sum;
    var t = document.createElement('span');
    t.className = 'wz-search-text';
    t.innerHTML = 'Cerca <b>' + WORDS[0] + '</b>';
    box.appendChild(t);
    var b = t.querySelector('b'), i = 0;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    setInterval(function () {
      if (sum.matches(':hover')) return;
      b.classList.add('wz-out');
      setTimeout(function () { i = (i + 1) % WORDS.length; b.textContent = WORDS[i]; b.classList.remove('wz-out'); }, 250);
    }, 2200);
  }
  smartSearch();
  function init() { social(); drawerWA(); drawerSearch(); search(); productOnlyForms(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
